<div style="align-items: center; justify-content: center; display: flex; height: 100vh;">
    <div style="text-align: center;">
        <div class="cpo-section-container">
            <p style="font-family: Booton; font-size: 16px; font-weight: 400; color: var(--green-800);">Enter your email and invoice number to view and pay your invoice.</p>
            <app-textbox
            [label]="'Email'"
            [(ngModel)]="customerEmail"
            >
            </app-textbox>
            <app-textbox
                [label]="'Invoice Number'"
                [(ngModel)]="invoiceNumber"
            >
            </app-textbox>
            <br>
            @if (errorMessage) {
                <div style="background-color: var(--red-hover); padding: 0.5px;">
                    <p style="font-family: Booton; font-size: 16px; font-weight: 400; color: var(--green-900);">Invoice not found</p>
                </div>
            }
            <button class="btn-core" (click)="getInvoice()" [disabled]="!customerEmail || !invoiceNumber" keyup.enter="getInvoice()">Submit</button>
        </div>
    </div>
</div>